// extracted by mini-css-extract-plugin
module.exports = {"success":"SuccessMessage_success__2w9cZ","icon":"SuccessMessage_icon__1D1HD"};